import Portal from "@common/controls/Portal/component";
import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { Editor, Range } from "slate";
import { useFocused, useSlate } from "slate-react";
import Menu from "../Menu";
import { type RichEditorToolbarButtons } from "../types";

type Props = {
  dropdownClassName?: string;
  menu: RichEditorToolbarButtons;
};
const HoveringToolbar = (props: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const editor = useSlate();
  const inFocus = useFocused();

  useEffect(() => {
    const el = ref.current;
    const { selection } = editor;

    if (!el) {
      return;
    }

    if (!selection || !inFocus || Range.isCollapsed(selection) || Editor.string(editor, selection) === "") {
      el.removeAttribute("style");
      return;
    }

    const domSelection = window.getSelection();
    const domRange = domSelection!.getRangeAt(0);
    const rect = domRange.getBoundingClientRect();
    el.style.opacity = "1";
    el.style.top = `${rect.top + window.scrollY - el.offsetHeight}px`;
    el.style.left = `${rect.left + window.scrollX - el.offsetWidth / 2 + rect.width / 2}px`;
  });

  return (
    <Portal>
      <Menu
        ref={ref}
        className={classNames("hovering", props.dropdownClassName)}
        dropdownClassName={props.dropdownClassName}
        menu={props.menu}
      />
    </Portal>
  );
};

export default HoveringToolbar;
